// extracted by mini-css-extract-plugin
module.exports = {"toggleMegaMenu":"MegaMenu_toggleMegaMenu__V_gmL","megaMenuContainer":"MegaMenu_megaMenuContainer___z8I9","navOverlay":"MegaMenu_navOverlay__WcjsH"};